// Kyodan Custom Tracking

// Breadcrumb link clicks
let breadcrumbLinks = document.querySelectorAll('.product-single__meta .breadcrumb a');

if(breadcrumbLinks !== null){
    breadcrumbLinks.forEach(link => {
        link.addEventListener('click', () => {
            gtag('event', 'click', {
                'link_area': 'Breadcrumb',
                'link_name': link.innerHTML
            });
        });
    });
}

// Quick add icon clicks
let quickAddBtns = document.querySelectorAll('.quick-add-btn');

if(quickAddBtns !== null){
    quickAddBtns.forEach(btn => {
        btn.addEventListener('click', () => {
            gtag('event', 'click', {
                'link_area': 'Collection Grid',
                'link_type': 'quick_add'
            });
        });
    });
}

// Custom wishlist heart icon in nav, linking to Wishlist King page
let wishlistIcon = document.querySelector('#HeaderWishlistLink');

if(wishlistIcon !== null){
  wishlistIcon.addEventListener('click', () => {
    gtag('event', 'click', {
        'link_area': 'Nav Icons',
        'link_type': 'wishlist_page'
    });
  });
}

// Mobile shortcut links
let shortcutLinks = document.querySelectorAll('.shortcut-grid a');

if(shortcutLinks !== null){
    shortcutLinks.forEach(link => {
        link.addEventListener('click', () => {
            let label = link.querySelector('.collection-item__title').innerHTML;

            gtag('event', 'click', {
                'link_area': 'Mobile Shortcuts',
                'link_name': label
            });
        });
    });
}

// Kyodan GWP Buttons in UpCart, with event delegation
document.body.addEventListener('click', (event) => {
    switch (event.target.id){
      case 'womenActivate':
        gtag('event', 'click', {
         'link_area': 'GWP Buttons',
         'link_name': 'Add Women'
        });
  
        break;
      case 'menActivate':
        gtag('event', 'click', {
         'link_area': 'GWP Buttons',
         'link_name': 'Add Men'
        });
        
        break;
      default:
        break;
    }
  });